import {
  Component,
  Inject,
  ViewEncapsulation,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import * as html2pdf from "html2pdf.js";
import * as _ from "lodash";
import { Subscription } from "rxjs/Subscription";

import * as jsPDF from "jspdf";
import * as html2canvas from "html2canvas";

/**Local file */

import { spekwoType, spekWalk, spekwo } from "../../utils/index";

import { SolutionFormService } from "../solutionForm/solutionForm.service";

import { CapitalizePipe } from "../../pipesFiles/capitalize.pipe";
import { environment } from "../../../../../../environments/environment";

@Component({
  selector: "fuse-contacts-contact-form-dialog",
  templateUrl: "./printDialog.component.html",
  styleUrls: ["./printDialog.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [CapitalizePipe],
})
export class printDialogComponent {
  spekwoType = spekwoType;
  spekWalk = spekWalk;
  spekwoValues = spekwo;

  allSolutionEstimate = [];
  chunkArray = [];

  totalCost: number = 0.0;
  orderId: number;
  orderType: string;
  currentOrderDetails: any;
  insReportId: string;
  buyerProperty: string;
  fullName: string;
  agent: string;
  clientName: string;
  isResults: boolean = false;
  fromPage: string;
  fullAddress: string;
  clientRequestHrs: string;
  quoteCompletedTime: any;
  addressWithOutCode: string;
  quoteCompletedTimeInMints: any;
  allSolutionEstimateList = [];
  clientRole: string;
  isHidden: boolean = true;
  quoteRequestedDate: any;
  approveDateTime: any;

  currentOrderChangedSubscription: Subscription;
  insReportIdChangeSubscription: Subscription;
  orderTypeChangeSubscription: Subscription;
  buyerPropertyChangesSubscription: Subscription;
  clientRoleChangeSubscription: Subscription;
  clientNameSubscription: Subscription;
  clientPropertyRoleChangeSubscription: Subscription;
  displayCusUrl = environment.displayCusUrl;
  @ViewChild('printForm') content: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<printDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,

    /**Service file */
    public solutionFormService: SolutionFormService,

    /**pipe file */
    public capitalizePipe: CapitalizePipe
  ) {
    this.allSolutionEstimate = this.data.arrayData;
    // this.checkItems(this.allSolutionEstimate);
    this.orderType = this.data.orderType;
    this.fromPage = this.data.pageType;

    _.each(this.allSolutionEstimate, (data) => {
      this.totalCost = Number(this.totalCost) + Number(data.totalCost);
    });
  }

  ngOnInit() {
    let splittingArray = [];
    let solutionCount = 0;
    let descCount = 0;

    console.log('this.allSolutionEstimate', this.allSolutionEstimate);

    this.allSolutionEstimate.forEach((item) => {
      solutionCount = solutionCount + item.solution ? item.solution.length : 0;
      descCount = descCount + item.description ? item.description.length : 0;
      if (solutionCount <= 2000 || descCount <= 2000) {
        splittingArray.push(item);
      }
      else {
        this.allSolutionEstimateList.push(splittingArray);
        solutionCount = 0;
        descCount = 0;
        splittingArray = [];
        splittingArray.push(item);
        solutionCount = solutionCount + item.solution ? item.solution.length : 0;
        descCount = descCount + item.description ? item.description.length : 0;
      }
    });
    if (splittingArray.length > 0) {
      if (splittingArray.length > 24) {
        let finalSplitArray = [];
        splittingArray.forEach((field, i) => {
          if ((i % 24) != 23) {
            finalSplitArray.push(field);
          }
          else {
            this.allSolutionEstimateList.push(finalSplitArray);
            finalSplitArray = [];
            finalSplitArray.push(field);
          }
        })
        if (finalSplitArray.length > 0) {
          this.allSolutionEstimateList.push(finalSplitArray);
        }
      }
      else {
        this.allSolutionEstimateList.push(splittingArray);
      }
    }

    // this.allSolutionEstimate.forEach((item) => {
    //   solutionCount = solutionCount + item.solution.length;
    //   descCount = descCount + item.description.length;
    //   if (solutionCount <= 500 || descCount <= 500) {
    //     splittingArray.push(item);
    //   }
    //   else {
    //     this.allSolutionEstimateList.push(splittingArray);
    //     solutionCount = 0;
    //     descCount = 0;
    //     splittingArray = [];
    //     splittingArray.push(item);
    //     solutionCount = solutionCount + item.solution.length;
    //     descCount = descCount + item.description.length;
    //   }
    // });
    // if (splittingArray.length > 0) {
    //   if(splittingArray.length > 10){
    //     let finalSplitArray = [];
    //     splittingArray.forEach((field, i) => {
    //       if((i%10)!=9){
    //         finalSplitArray.push(field);
    //       }
    //       else{
    //         this.allSolutionEstimateList.push(finalSplitArray);
    //         finalSplitArray = [];
    //         finalSplitArray.push(field);
    //       }
    //     })
    //     if(finalSplitArray.length > 0){
    //       this.allSolutionEstimateList.push(finalSplitArray);
    //     }
    //   }
    //   else{
    //     this.allSolutionEstimateList.push(splittingArray);
    //   }
    // }
    this.currentOrderChangedSubscription =
      this.solutionFormService.currentOrderChanged.subscribe(
        (res) => {
          if (res) {
            this.currentOrderDetails = res;
            this.fullName =
              res.billing.first_name + " " + res.billing.last_name;
            this.fullAddress = res.billing.city && res.billing.state && res.billing.postcode ? res.billing.city + ", " + res.billing.state + ", " + res.billing.postcode : (res.billing.city && res.billing.state && !res.billing.postcode ? res.billing.city + ", " + res.billing.state : (res.billing.city && !res.billing.state && res.billing.postcode ? res.billing.city + ", " + res.billing.postcode : (!res.billing.city && res.billing.state && res.billing.postcode ? res.billing.state + ", " + res.billing.postcode : (!res.billing.city && !res.billing.state && res.billing.postcode ? res.billing.postcode : (!res.billing.city && res.billing.state && !res.billing.postcode ? res.billing.state : (res.billing.city && !res.billing.state && !res.billing.postcode ? res.billing.city : ""))))))
            this.clientRequestHrs =
              res.line_items &&
                res.line_items.length > 0 &&
                res.line_items[0].meta_data &&
                res.line_items[0].meta_data.length > 0 &&
                res.line_items[0].meta_data[0].value
                ? res.line_items[0].meta_data[0].value.match(/\d+/g).join('')
                : "";
            this.addressWithOutCode =
              res.billing.city && res.billing.state ? res.billing.city + ", " + res.billing.state : (res.billing.city && !res.billing.state ? res.billing.city : (!res.billing.city && res.billing.state ? res.billing.state : ""));
          }
        },
        () => { }
      );

    /**Inspection id  */
    this.insReportIdChangeSubscription =
      this.solutionFormService.insReportIdChange.subscribe((insRes) => {
        this.insReportId = insRes && insRes.insReportId;
      });

    /**Order type */
    this.orderTypeChangeSubscription =
      this.solutionFormService.orderTypeChange.subscribe((typeRes) => {
        this.orderType = typeRes;
      });

    /**Buyer property */

    this.buyerPropertyChangesSubscription =
      this.solutionFormService.buyerPropertyChanges.subscribe((propertyRes) => {
        this.buyerProperty = propertyRes;
      });

    /**Client  role */
    this.clientRoleChangeSubscription =
      this.solutionFormService.clientRoleChange.subscribe((roleRes) => {
        this.agent = this.spekwoValues[roleRes];
      });

    /**Client  Name -not billing name .Its separate field */
    this.clientNameSubscription =
      this.solutionFormService.clientNameChange.subscribe((data) => {
        this.clientName = data && data.name;
      });

    this.clientPropertyRoleChangeSubscription =
      this.solutionFormService.clientPropertyRoleChange.subscribe((roleRes) => {
        this.clientRole = roleRes;
      });

    // diff b/w quote request and deliver
    console.log('this.data', this.data);
    this.quoteRequestedDate = this.convertUtcToEst(this.data.quoteRequestedDate);
    this.approveDateTime = this.convertUtcToEst(this.data.arrayData[0].approveDatetime);
    let quoteRequestedDate = new Date(this.quoteRequestedDate);
    let quoteDeliveredDate = new Date(this.convertUtcToEst(this.data.arrayData[0].approveDatetime));
    // this.quoteCompletedTimeInMints = Math.floor(
    //   (quoteDeliveredDate.getTime() - quoteRequestedDate.getTime()) / 1000 / 60
    // );
    this.convertMinsToHrsMins(quoteRequestedDate, quoteDeliveredDate);
  }

  convertMinsToHrsMins(quoteRequestedDate, quoteDeliveredDate) {
    const timeDifference = Math.abs(quoteRequestedDate - quoteDeliveredDate); // Get the absolute difference in milliseconds
    // Convert the time difference to hours, minutes, and seconds
    const hours = Math.floor(timeDifference / 3600000);
    const minutes = Math.floor((timeDifference % 3600000) / 60000);
    const seconds = Math.floor((timeDifference % 60000) / 1000);
    this.quoteCompletedTime = hours + " hours and " + minutes + " minutes";
  }

  convertUtcToEst(timeStamp) {
    if (timeStamp) {
      const gmtTimestamp = timeStamp;

      const gmtDate = new Date(gmtTimestamp);

      const estFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short',
      });

      // Format the GMT date to EST
      let estDateTime = estFormatter.format(gmtDate);
      estDateTime = estDateTime.replace(/\s\w+$/, '');
      return estDateTime;
    }

    return "";
  }

  convertUTCToEST(utcTimeString) {
    const utcDate = new Date(utcTimeString);
    const estOffset = -4 * 60; // EST is UTC-5
    const estTimestamp = utcDate.getTime() + (estOffset * 60 * 1000);
    const estDate = new Date(estTimestamp);
    return estDate.toISOString().replace("Z", "");
  }

  ngOnDestroy() {
    this.currentOrderChangedSubscription.unsubscribe();
    this.insReportIdChangeSubscription.unsubscribe();
    this.orderTypeChangeSubscription.unsubscribe();
    this.buyerPropertyChangesSubscription.unsubscribe();
    this.clientRoleChangeSubscription.unsubscribe();
    this.clientNameSubscription.unsubscribe();
  }

  checkItems(allSolutionEstimate) {
    this.chunkArray = [];
    var chunk_size = 15;

    while (allSolutionEstimate.length > 0) {
      this.chunkArray.push(allSolutionEstimate.splice(0, chunk_size));
    }

    // return this.chunkArray;
    console.log("results", this.chunkArray);
  }

  confirmSelection() {
    this.isHidden = false;
    var element = document.getElementById("printForm");
    // var pageBreak = document.createElement('div');
    // pageBreak.className = 'html2pdf__page-break';
    // element.parentElement.insertBefore(pageBreak, element);

    var name = this.capitalizePipe.transform(this.fullName);
    var buyerProperty = this.capitalizePipe.transform(this.buyerProperty);
    const contentHtml = this.content.nativeElement;
    const tableContainer = contentHtml.querySelector('.table-container');
    tableContainer.style.height = '1300px';
    const pageContainer = contentHtml.querySelector('.page-container');
    pageContainer.style.height = '1300px';

    var opt = {
      margin: 1,
      filename: name + "-" + buyerProperty + "-" + "Solution Estimation.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: { useCORS: false, scale: 2 },
      jsPDF: { unit: "cm", format: "a2", orientation: "p" },
      pagebreak: {
        mode: "avoid-all",
        after: ".break-after",
        before: ".break-before",
      },
    };
    html2pdf()
      .from(element)
      .set(opt)
      .toPdf()
      .get("pdf")
      .then(function (pdf) {
        var totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(15);
          if (i == 1) {
            pdf.text(' '.repeat(5) + "www.speKwo.com" + ' '.repeat(59) + "Have Questions? Call us 866.646.0200 or Email us info@speKwo.com" + ' '.repeat(59) + "Page " + i + " of " + totalPages, (0), (pdf.internal.pageSize.getHeight() - 0.3));
          }
          else if (i > totalPages - 2) {
            pdf.text(' '.repeat(10) + "Office.866.646.0200" + ' '.repeat(48) + "Website: speKwo.com" + ' '.repeat(48) + "Email: Info@speKwo.com" + ' '.repeat(48) + "Page " + i + " of " + totalPages, (0), (pdf.internal.pageSize.getHeight() - 0.3));
          }
          else {
            pdf.text("Page " + i + " of " + totalPages, (39), (pdf.internal.pageSize.getHeight() - 0.3));
          }
        }
      })
      .save();
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/printDialog/printDialog.component.ts